/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface FlightTravelerLoyaltyAccount
 */
export interface FlightTravelerLoyaltyAccount {
    /**
     *
     * @type {string}
     * @memberof FlightTravelerLoyaltyAccount
     */
    airlineIataCode: string;
    /**
     *
     * @type {string}
     * @memberof FlightTravelerLoyaltyAccount
     */
    accountNumber: string;
}

/**
 * Check if a given object implements the FlightTravelerLoyaltyAccount interface.
 */
export function instanceOfFlightTravelerLoyaltyAccount(value: object): value is FlightTravelerLoyaltyAccount {
    if (!('airlineIataCode' in value) || value['airlineIataCode'] === undefined) return false;
    if (!('accountNumber' in value) || value['accountNumber'] === undefined) return false;
    return true;
}

export function FlightTravelerLoyaltyAccountFromJSON(json: any): FlightTravelerLoyaltyAccount {
    return FlightTravelerLoyaltyAccountFromJSONTyped(json, false);
}

export function FlightTravelerLoyaltyAccountFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlightTravelerLoyaltyAccount {
    if (json == null) {
        return json;
    }
    return {

        'airlineIataCode': json['airline_iata_code'],
        'accountNumber': json['account_number'],
    };
}

export function FlightTravelerLoyaltyAccountToJSON(json: any): FlightTravelerLoyaltyAccount {
    return FlightTravelerLoyaltyAccountToJSONTyped(json, false);
}

export function FlightTravelerLoyaltyAccountToJSONTyped(value?: FlightTravelerLoyaltyAccount | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'airline_iata_code': value['airlineIataCode'],
        'account_number': value['accountNumber'],
    };
}
